export default __webpack_public_path__ + "static/media/svg-1.d3eabfa4.svg";